/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { CreateDeathEventPageService } from '@/pages/CreateDeathEventPage/services';
import { logger as log } from '@common/logger';

const getSrv = () => {
  return vappContainer.get<CreateDeathEventPageService>(
    CreateDeathEventPageService.displayName
  );
};

export const createDeathEvent = async (context: any, event: any) => {
  const currentState = 'UPDATE_KYC';
  const method = 'updateKyc';

  // @ts-ignore
  return new Promise(async (resolve, reject) => {
    try {
      log.log('context: ', context, 'event: ', event);
      const srv = getSrv();
      const _getArgs = () => {
        let _args: any = {};
        if (event?.type === 'START') {
          _args = context['UPDATE_KYC'];
        }
        if (event?.type === 'TRIGGER_REFRESH') {
          _args = {
            offset: event?.offset,
            size: event?.size,
            where: event?.where ?? [],
          };
        }
        return _args;
      };
      const shelves = await srv.agent.getcreateDeathEvent(event?.payload);
      if (shelves) {
        return resolve({
          key: 'UPDATE_KYC_SUCCESS',
          value: {
            ...(shelves || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(`error in ${method}, msg: ${msg}`);
        return reject({
          key: 'UPDATE_KYC_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(`error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'UPDATE_KYC_FAILED',
        value: err?.message,
      });
    }
  });
};
